import AIAnalyst from './AIAnalyst';

export default AIAnalyst;
export { AIAnalyst };
